import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { FormattedDate } from 'react-intl';

import { ListItem } from 'material-ui/List';

import ContextIconMenu from '../Common/ContextIconMenu';
import InfoIcon from 'material-ui/svg-icons/action/info';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import SubjectIcon from 'material-ui/svg-icons/action/subject';
import LaunchIcon from 'material-ui/svg-icons/action/launch';
import VideoIcon from 'material-ui/svg-icons/av/video-library';
import DocumentIcon from 'material-ui/svg-icons/action/description';
import ImageIcon from 'material-ui/svg-icons/image/image';
import AudioIcon from 'material-ui/svg-icons/av/library-music';
import AssetIcon from 'material-ui/svg-icons/editor/insert-drive-file';

import { statusColours } from '../../constants/ColourConstants';

import AssetActions, { editAsset } from '../../actions/AssetActionCreator';

import ROLES from '../../constants/Roles';

const style = {
    listItem: {
        padding: '2px',
    },
    icon: {
        height: '32px',
        width: '32px',
    }
};

const getActions = (row) => [
    {
        link: `/cent/asset/${row.id}/download`,
        target: '_blank',
        label: 'Download',
        icon: <InfoIcon />,
        condition: {
            fields: {
                asAttachment: true
            }
        }
    },
    {
        type:'divider'
    },
    {
        action: () => editAsset(row.id, true),
        icon: <EditIcon />,
        label: 'Edit',
        condition: {
            show: !!row.asAttachment,
            roles: [ROLES.ADMIN]
        }
    },
    {
        link: `/dashboard/asset/${row.id}/edit`,
        icon: <EditIcon />,
        label: 'Edit',
        condition: {
            show: !row.asAttachment,
            roles: [ROLES.ADMIN]
        }
    },
    {
        type: 'deleteDialog',
        dialogType: 'menu',
        value: row.id,
        title: 'Delete',
        deleteAction: AssetActions.delete,
        message: (<span>Are you sure to delete the asset  "{row.name}" ?</span>),
        condition: {
            show:  row.sysStatus > 4,
            roles: [ROLES.ADMIN]
        }
    }
];

const AssetListItem = ({data, actions}) => {

    const infoLink = `/dashboard/asset/${data.id}`;
    const iconColor = statusColours.primary;

    let avatarIcon = (<AssetIcon style={style.icon} color={iconColor} />);
    let description = '';
    let statusLine = '';

    if (!!data.dateAdded) {
        description = <FormattedDate
            value={data.dateAdded}
            day='numeric'
            weekday='long'
            year='numeric'
            month='long'
        />
    }

    switch (data.type) {

        case 'text':
            avatarIcon = (<SubjectIcon style={style.icon} color={iconColor}/>);
            break;

        case 'document':
            avatarIcon = (<DocumentIcon style={style.icon} color={iconColor}/>);
            break;

        case 'image':
            avatarIcon = (<ImageIcon style={style.icon} color={iconColor}/>);
            break;

        case 'video':
            avatarIcon = (<VideoIcon style={style.icon} color={iconColor}/>);
            break;

        case 'e-learning':
            avatarIcon = (<LaunchIcon style={style.icon} color={iconColor}/>);
            break;

        case 'audio':
            avatarIcon = (<AudioIcon style={style.icon} color={iconColor}/>);
            break;

        default:
            break;
    }
    let leftAvatar = <Link to={infoLink}>{avatarIcon}</Link>;
    if (!!data.asAttachment) {
        leftAvatar = <Link to={`/cent/asset/${data.id}/download`} target="_blank">{avatarIcon}</Link>;
    }
    const actionList = (actions || getActions(data));
    const rightIcon = (!!actionList && actionList.length > 0)
        ? (<ContextIconMenu actions={actionList} data={data}/>)
        : undefined;

    return (
        <ListItem
            key={data.id}
            style={style.listItem}
            leftAvatar={leftAvatar}
            primaryText={
                <Link to={infoLink} className="primaryText">
                    {data.name}
                </Link>
            }
            secondaryText={
                <Link to={infoLink} className="secondaryText">
                    {description}<br/>
                    {statusLine}
                </Link>
            }
            secondaryTextLines={2}
            rightIcon={rightIcon}
        />
    )
};

AssetListItem.propTypes = {
    readOnly: PropTypes.bool
};

AssetListItem.defaultProps = {
    readOnly: false
};

export default AssetListItem;
